export default "__VITE_ASSET__By9RsPUN__"